import React from 'react';
import PropTypes from 'prop-types';
import TransactionKeyTag from './TransactionKeyTag';

const fontStyle = {
  fontSize: '8px'
};

const TransactionKey = ({ data }) => {

  let penaltyInterestContent;
  let vatContent;
  let accruedContent;
  let outlaidContent;

  if (data.calculateInterest === true){
    penaltyInterestContent = (
      <TransactionKeyTag color={'#ff0000'} type={'D'} description={'Dráttavextir'}/>
    );
  }

  if (data.calculateVat === true){
    vatContent = (
      <TransactionKeyTag color={'#ff00ff'} type={'V'} description={'VSK'}/>
    );
  }

  if (data.natureType === 1){
    accruedContent = (
      <TransactionKeyTag color={'#0000ff'} type={'Á'} description={'Áfallinn'}/>
    );
  }

  if (data.natureType === 2){
    outlaidContent = (
      <TransactionKeyTag color={'#0000ff'} type={'Ú'} description={'Útlagður'}/>
    );
  }

  return (
    <div>
      <span>{data.key}</span> <span style={fontStyle}>{data.name}  </span>{penaltyInterestContent}{vatContent}{accruedContent}{outlaidContent}
    </div>
  );
};

TransactionKey.propTypes = {
  data: PropTypes.object,
};

export default TransactionKey;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Display/TransactionKey.js